export default __webpack_public_path__ + "static/media/img5.65febc75.png";